import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUp, Calendar, Phone } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { BUSINESS } from "@/data/content";

export function ScrollProgress() {
  const [w, setW] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      setW(total > 0 ? (window.scrollY / total) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div className="scroll-progress" style={{ width: `${w}%` }} />;
}

export function FloatingActions() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Link
        to="/book"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold pl-5 pr-6 py-4 rounded-full shadow-2xl shadow-blue-600/40 transition-all hover:scale-105 glow"
        data-testid={HOME.fab}
      >
        <Calendar className="h-5 w-5" />
        Book Now
      </Link>

      <a
        href={`tel:${BUSINESS.phoneRaw}`}
        className="fixed bottom-6 left-6 z-40 md:hidden inline-flex items-center justify-center bg-white text-[#050914] h-14 w-14 rounded-full shadow-2xl shadow-white/20"
        data-testid="mobile-call-fab"
        aria-label="Call us"
      >
        <Phone className="h-5 w-5" />
      </a>

      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-28 right-6 z-40 h-11 w-11 grid place-items-center rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white hover:bg-white/10 transition-all"
          data-testid={HOME.scrollTop}
          aria-label="Scroll to top"
        >
          <ArrowUp className="h-4 w-4" />
        </button>
      )}
    </>
  );
}

export function Particles({ count = 18 }) {
  const items = Array.from({ length: count });
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {items.map((_, i) => (
        <span
          key={i}
          className="particle"
          style={{
            left: `${(i * 37) % 100}%`,
            bottom: `-${(i * 13) % 30}px`,
            animationDelay: `${(i * 1.1) % 18}s`,
            animationDuration: `${14 + ((i * 3) % 10)}s`,
            background:
              i % 3 === 0
                ? "rgba(96, 165, 250, 0.55)"
                : "rgba(255,255,255,0.3)",
          }}
        />
      ))}
    </div>
  );
}
